import { CampaignCardFooterProps } from './campaign-card-footer-types';
import {
    RewardsContainer,
    IconWrapper,
    BottomCampaignCard
} from './style-component';
import SpaceshipIcon from '@/assets/icons/spaceship-icon/spaceship-icon.svg';
import SpaceshipIconDark from '@/assets/icons/spaceship-icon-dark/spaceship-icon-dark.svg';
import { TimeInfo } from '@/components/time-info/time-info';
import { useTheme } from '@/contexts/theme-context/useThemeContext';
import { calculateTimeStatus } from '@/utils/calculate-time-status/calculate-time-status';
import ProgressBar from '@/components/progress-bar/progress-bar';

export const CampaignCardFooter: React.FC<CampaignCardFooterProps> = ({
    endDate,
    startDate,
    rewards,
    isCompleted
}) => {
    const { current, total } = rewards;
    const theme = useTheme();
    const status = calculateTimeStatus({
        startDate: startDate,
        endDate: endDate,
        isCompleted: isCompleted
    });

    return (
        <BottomCampaignCard>
            <TimeInfo
                isCampaign={true}
                endDate={endDate}
                startDate={startDate}
                status={status}
            />
            <RewardsContainer>
                <IconWrapper>
                    <img src={theme?.theme?.name === 'dark' ? SpaceshipIcon : SpaceshipIconDark} alt="rewards" />
                </IconWrapper>
                <ProgressBar 
                    progress={current} 
                    maxProgress={total} 
                    minProgress={total} 
                    status={current > 0 && total > 0 && current >= total ? 'completed':'inCourse'} 
                    isClaimed={false} 
                    isExChange={true}
                />
            </RewardsContainer>
        </BottomCampaignCard>
    );
};
